import { copytext } from 'Lib/copy-text/copy-text';

const startTime = new Date().getTime();
const delay = 3000; // Попап открывается через 3 секунды после загрузки страницы
const $popupPromocode = $('.popup-promocode');

$('.popup-promocode__copy-icon').on('click', () => {
    copytext('.popup-promocode__promocode');
});

$('.popup-promocode__close').on('click', () => {
    $popupPromocode.remove();
});

$(window).on('load', () => {
    const timeLeft = new Date().getTime() - startTime;

    if (timeLeft < delay) {
        setTimeout(() => {
            $popupPromocode.css('display', 'block');
        }, delay - timeLeft);
    } else {
        $popupPromocode.css('display', 'block');
    }
});